import { Message } from "element-ui";
import store from '@/store'
import router from '@/router'
export const ErrorType = {
  ABORT: 2,
  NETWORK: 3,
  EXPIRE: 401,
  INTERAL: 500,
}

export function setErrorMessage(status, aiContent) {

  if (status === 401) {
    Message({
      message: '登录过期，请重新登录',
      type: 'error'
    })
    store.commit("removeUser")
    store.commit("removeToken")
    store.commit("CLEAR_MESSAGE");
    router.push('/login')
  }
  if (!['', 'loading'].includes(aiContent.msg)) return;
  aiContent.msg = ""
  aiContent.isDone = status;
  const messages = {
    [ErrorType.ABORT]: '请求已取消',
    [ErrorType.NETWORK]: '网络出错',
    [ErrorType.EXPIRE]: '登录过期，请重新登录',
    [ErrorType.INTERAL]: '服务器异常'
  };

  aiContent.msg = messages[status];
  if (aiContent.parts.length === 0) {
    aiContent.parts.push({ msg: aiContent.msg, questions: {} });
  }
}

export async function handleFetchError(error, aiContent, question) {
  question && (question.isLoading = false);
  if (!aiContent) return;
  aiContent.isSlow = false;

  // ★ 新增：有续传凭证的非主动取消错误 → paused
  if (error.name !== 'AbortError' && aiContent.params?.requestId && !aiContent._aborted) {
    aiContent._paused = true;
    if (aiContent.msg === 'loading') aiContent.msg = '';
    return;   // 不 setErrorMessage、不写 isDone=3
  }

  if (error.name === 'AbortError') {
    setErrorMessage(ErrorType.ABORT, aiContent);
    console.log('Request aborted:', error);
  } else {
    question && Message.error(error || "请求失败，请稍后再试");
    setErrorMessage(ErrorType.NETWORK, aiContent);
    console.error('Request failed:', error);
  }
  await store.dispatch('updateMessageToConversation', {
    message: aiContent
  });
}